module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "animation-underlay"
  }), _vm._v(" "), _c('wave-scene', {
    staticClass: "animation-tile",
    attrs: {
      "framesPerSecond": 30
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cover-text"
  }, [_vm._v("Rachel Frantsen Lee")]), _vm._v(" "), _c('div', {
    staticClass: "clickable-overlay",
    on: {
      "click": _vm.navigateNext
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e22b25a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/Cover.vue
// module id = 116
// module chunks = 1